import axios from 'axios';

import { getData } from '@feature/utils';

import {
  TravelReferenceDocumentKind,
  TravelReferenceDocumentSlot,
  TravelReferenceDocumentSlotRef,
  TravelReferenceDocumentUploadRequest,
} from './TravelReferenceDocumentTypes';

export function getAll() {
  return axios.get<TravelReferenceDocumentSlot[]>('/travel/reference-documents').then(getData);
}

export function getSlots() {
  return axios.get<TravelReferenceDocumentSlot[]>('/travel/reference-documents/slots').then(getData);
}

export function upload(request: TravelReferenceDocumentUploadRequest) {
  const formData = new FormData();
  formData.append('file', request.file);

  return axios
    .put<TravelReferenceDocumentSlot>(`/travel/reference-documents/${request.kind}`, formData, {
      params: { role: request.role },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(getData);
}

export function deleteSlot({ kind, role }: TravelReferenceDocumentSlotRef) {
  return axios.delete<unknown>(`/travel/reference-documents/${kind}`, { params: { role } }).then(getData);
}

export function getContent(kind: TravelReferenceDocumentKind) {
  return axios.get<Blob>(`/travel/reference-documents/${kind}/content`, { responseType: 'blob' }).then(getData);
}

export function getSlotContent({ kind, role }: TravelReferenceDocumentSlotRef) {
  return axios
    .get<Blob>(`/travel/reference-documents/slots/${kind}/content`, { params: { role }, responseType: 'blob' })
    .then(getData);
}
